<template>
  <ul
    class="right-menu"
    v-show="showRightMenu"
    :style="{left: '191px', top: position.y}"
  >
    <template v-for="(item, index) in btnData">
      <li
        :key="index"
        v-if="item.isShow"
        @click.stop="oprateItem(item.code)"
      >
        <i class="li-icon" />{{ item.name }}
      </li>
    </template>
  </ul>
</template>
<script>
import { mapState } from 'vuex'
import APIS from '@apis/common.js'
export default {
  name: 'OperationSidebar',
  props: {
    positionValue: {
      type: Object,
      default: () => {
        return { x: 0, y: 0 }
      }
    },
    btnEnable: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState(['MenusOper']),
    menuId() {
      if (this.MenusOper.length === 0) return 0
      let menuId = this.MenusOper.find((item) => item.url === this.$route.path)
      return menuId.id
    },
    showBtn() {
      return {
        add: true,
        edit: true,
        delete: true,
        refresh: true
      }
    },
    position() {
      let length = 0
      this.btnData.forEach((item) => {
        item.isShow === true && length++
      })
      let x = this.positionValue.x + 'px'
      let y = this.positionValue.y - (length * 35) / 2 + 'px' // 35: li的高度
      return {
        x: x,
        y: y
      }
    },
    btnData() {
      let arr = []
      this.btnEnable.forEach((btnItem, index) => {
        arr.push({ code: btnItem.code, name: btnItem.name, isShow: btnItem.isShow })
        let hasCode = false
        this.operationData.forEach((item) => {
          if (item.code === btnItem.code) {
            hasCode = true
            arr[index].isShow = item.enabled === 1 && btnItem.isShow
          }
        })
        if (!hasCode && btnItem.code.indexOf('refresh') === -1 && btnItem.code.indexOf('config') === -1) {
          arr[index].isShow = false
        }
      })
      return arr
    }
  },
  watch: {
    MenusOper(newVal) {
      if (newVal.length !== 0) {
        let menuId = newVal.find((item) => item.url === this.$route.path)
        this.initBtnData(menuId)
      }
    },
    btnData: {
      handler(newV) {
        let allHidden = true
        newV.forEach((btnItem) => {
          if (btnItem.isShow === true) {
            allHidden = false
          }
        })
        if (allHidden) {
          this.showRightMenu = false
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      showRightMenu: false,
      operationData: []
    }
  },
  mounted() {
    document.addEventListener('click', () => {
      this.showRightMenu = false
    })
  },
  created() {
    if (this.menuId !== 0) {
      this.initBtnData(this.menuId)
    }
  },
  methods: {
    initBtnData() {
      let params = {
        menuId: this.menuId
      }
      APIS.sourceMenuOperations({ data: params }).then((resp) => {
        let { status, data } = resp
        if (status === 0) {
          let moveOperation = {
            moveup: false,
            movedown: false
          }
          this.operationData = data.map((item) => {
            if (item.code.indexOf('moveup') !== -1) {
              moveOperation.moveup = item.enabled === 1
            } else if (item.code.indexOf('movedown') !== -1) {
              moveOperation.movedown = item.enabled
            }
            return {
              name: item.name,
              code: item.code, // 简码
              enabled: item.enabled, // 是否启用 0-false,1-true
              dealCount: item.dealCount, // 处理文档个数
              needRefresh: item.needRefresh // 刷新
            }
          })
          this.$emit('initMoveOperation', moveOperation)
        }
      })
    },
    oprateItem(operate) {
      let namePath = operate.split('_')
      this.$emit('oprateItem', namePath[namePath.length - 1])
      this.showRightMenu = false
    },
    showRightMenuFunc() {
      let allHidden = true
      this.btnData.forEach((btnItem) => {
        if (btnItem.isShow === true) {
          allHidden = false
        }
      })
      if (allHidden) {
        this.showRightMenu = false
      } else {
        this.showRightMenu = !this.showRightMenu
      }
    }
  }
}
</script>
<style lang='scss' scoped>
// 操作按钮
.right-menu {
  width: 128px;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 10;
  li {
    line-height: 30px;
    margin: 0 15px;
    font-size: 12px;
    color: #666666;
    cursor: pointer;
    &:hover {
      color: #3273ff;
    }
    &:nth-child(1) {
      border-bottom: 1px solid #e6e6e6;
      line-height: 34px;
    }
    &:nth-child(4) {
      border-top: 1px solid #e6e6e6;
      line-height: 34px;
    }
    .li-icon {
      display: inline-block;
      vertical-align: middle;
      width: 7px;
      height: 7px;
      background: #3091f3;
      transform: rotate(45deg);
      margin-right: 6px;
    }
  }
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: -10px;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-right: 15px solid #fff;
  }
}
</style>
